export const environment = {
  name: 'qa',
  production: false,
  readonlyMode: false,
  proxyUrl: 'https://freshai-webproxy.qa.innovation.wendys.digital',
  voiceData: null,
  firebase: {
    apiKey: 'AIzaSyAsv_Q39bF9ogFAr04hrpgaLKkJVj6UoEg',
    appId: '1:1021965890439:web:fbe232b7205caea9311922',
    authDomain: 'voice-ai-dev-fb64.firebaseapp.com',
    measurementId: 'G-V20KV0YQQ5',
    messagingSenderId: '1021965890439',
    projectId: 'voice-ai-dev-fb64',
    storageBucket: 'voice-ai-dev-fb64.appspot.com',
  },
  speechRecognitionSoftTimeout: 15000,
  firebaseFunctionsUrl: 'https://us-central1-voice-ai-dev-fb64.cloudfunctions.net',
  launchDarklyBaseUrl: 'https://launchdarkly.app.tst.wendys.digital',
  locationServicesUrl: 'https://api.app.tst.wendys.digital/digital-integration-gateway',
  launchDarklyClientId: `60d9fc73e116bc0dc7fc2a61`,
  launchDarklyClientSDKKey: `sdk-38d39425-dd6d-437c-8d79-f43fd6e6fbb5`,
  defaultCorrelationId: 'DEFAULT',
  driveThruBffUrl: 'https://drivethru.qa.innovation.wendys.digital',
  baseImageUrl: 'https://app-test.wendys.com/unified/assets/menu',
  flipt: {
    url: 'https://flipt.app.tst.wendys.digital',
    namespace: 'freshai',
    environment: 'default',
  },
};
